import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

interface ContainerProps {
  multiline?: boolean
  disableBorder?: boolean
  fullWidth?: boolean
  disabled?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  container: (props: ContainerProps) => ({
    '&&': {
      width: '100%',
      padding: `${SPACES.xxs} ${SPACES.xxl} ${SPACES.s}`,
      backgroundColor: props.disabled
        ? theme.palette.custom.greyTransparent
        : theme.palette.custom.white,

      border: props.disableBorder ? 'none' : `1px solid ${theme.palette.custom.grey}`,

      [theme.breakpoints.down('tablet')]: {
        borderRadius: 10,
      },

      [theme.breakpoints.up('tablet')]: {
        width: props.multiline || props.fullWidth ? '100%' : 390,
        height: props.multiline ? 'auto' : 80,

        borderRadius: 15,
      },

      transition: 'background-color 0.3s ease-in-out',
    },
  }),

  label: {
    '&&': {
      padding: 0,
      marginBottom: 6,
      lineHeight: 1.4,
      fontSize: 10,
      color: theme.palette.custom.grey2,

      [theme.breakpoints.down('laptop')]: {
        fontWeight: FONTS.WEIGHTS.light,
      },
      [theme.breakpoints.up('tablet')]: {
        fontWeight: FONTS.WEIGHTS.medium,
      },
    },
  },
  input: (p: ContainerProps) => ({
    '&&': {
      height: 25,

      border: 'none',
      backgroundColor: theme.palette.custom.white,

      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      color: theme.palette.custom.darkBlue2,
      lineHeight: 1.35,

      transition: 'background-color 0.3s ease-in-out',

      '&:focus': {
        outline: 'none',
      },

      '&::placeholder': {
        color: theme.palette.custom.grey3,
      },

      '&:disabled': {
        textFillColor: theme.palette.custom.grey2,
        backgroundColor: 'inherit',
      },

      [theme.breakpoints.down('tablet')]: {
        fontSize: p.multiline ? FONTS.SIZES.m : FONTS.SIZES.xxl,
        fontWeight: FONTS.WEIGHTS.light,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xxl,
        fontWeight: FONTS.WEIGHTS.light,
        padding: 0,
      },
    },
  }),
}))

export default useStyles
